module.exports = __webpack_public_path__ + "static/media/photo7.1680ff54.jpg";